// localStorage was called raw (localStorage.getItem/setItem/removeItem)
// in 33 places across the SAT section, all for the same key. In some
// browser contexts - notably older Safari in certain private-browsing
// configurations, or a site with cookies/storage explicitly blocked -
// touching localStorage at all throws a SecurityError, not just returns
// null. An unguarded call there previously meant that specific page
// crashing (caught by the new app-wide ErrorBoundary, but still a broken
// page) instead of the student just being treated as logged-out, which is
// what should happen: no session token available, no session token used.
const TOKEN_KEY = 'student_session_token';

export function getSessionToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setSessionToken(token) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
    return true;
  } catch {
    return false;
  }
}

export function clearSessionToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    // nothing to clean up if storage was never reachable in the first place
  }
}
